// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/videoChat/volume.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/videoChat/screen.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/videoChat/mic.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/videoChat/close.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/videoChat/videocam.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/videoChat/setting.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/videoChat/expand.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.videoChat{
    position: relative;
    min-width: 400px;
    min-height: 300px;
    width: 100%;
    height: 100%;
}

.videoChat_videos{
    /*position: absolute;*/
    width: 100%;
    height: 100%;
}

.videoChat_video{
    border-radius: 24px;
    width: 100%;
    height: 100%;
    background-color: #222;
    overflow: hidden;
}

.videoChat_video_element{
    width: 100%;
    display: block;
}

.videoChat_video_opponent{
    border-radius: 24px;
    position: absolute;
    width: 30%;
    height: 30%;
    top: 23px;
    right: 21px;
    background-color: #333;
}

.videoChat_controls{
    position: absolute;
    padding: 23px 21px;
    bottom: 0;
    left: 0;
    display: flex;
    gap: 19px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.videoChat_controls_left{
    display: flex;
    gap: 19px;
    align-items: center;
}

.videoChat_controls_center{
    display: flex;
    gap: 19px;
    align-items: center;
}

.videoChat_controls_right{
    display: flex;
    gap: 19px;
    align-items: center;
}

.videoChat_control{
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    background-color: #FAFAFB;
    border-radius: 100%;

    background-position: center;
    background-size: 19px;
    background-repeat: no-repeat;
}

.videoChat_control_volume{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.videoChat_control_screen{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.videoChat_control_mic{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.videoChat_control_close{
    width: 57px;
    height: 57px;
    background-color: #E23424;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.videoChat_control_camera{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.videoChat_control_setting{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.videoChat_control_expand{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
`, "",{"version":3,"sources":["webpack://./src/components/videoChat/VideoChat.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,yBAAyB;IACzB,mBAAmB;;IAEnB,2BAA2B;IAC3B,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,yDAA0D;AAC9D;;AAEA;IACI,yDAA0D;AAC9D;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA;IACI,yDAA4D;AAChE;;AAEA;IACI,yDAA2D;AAC/D;;AAEA;IACI,yDAA0D;AAC9D","sourcesContent":[".videoChat{\n    position: relative;\n    min-width: 400px;\n    min-height: 300px;\n    width: 100%;\n    height: 100%;\n}\n\n.videoChat_videos{\n    /*position: absolute;*/\n    width: 100%;\n    height: 100%;\n}\n\n.videoChat_video{\n    border-radius: 24px;\n    width: 100%;\n    height: 100%;\n    background-color: #222;\n    overflow: hidden;\n}\n\n.videoChat_video_element{\n    width: 100%;\n    display: block;\n}\n\n.videoChat_video_opponent{\n    border-radius: 24px;\n    position: absolute;\n    width: 30%;\n    height: 30%;\n    top: 23px;\n    right: 21px;\n    background-color: #333;\n}\n\n.videoChat_controls{\n    position: absolute;\n    padding: 23px 21px;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    gap: 19px;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.videoChat_controls_left{\n    display: flex;\n    gap: 19px;\n    align-items: center;\n}\n\n.videoChat_controls_center{\n    display: flex;\n    gap: 19px;\n    align-items: center;\n}\n\n.videoChat_controls_right{\n    display: flex;\n    gap: 19px;\n    align-items: center;\n}\n\n.videoChat_control{\n    width: 42px;\n    height: 42px;\n    flex-shrink: 0;\n    background-color: #FAFAFB;\n    border-radius: 100%;\n\n    background-position: center;\n    background-size: 19px;\n    background-repeat: no-repeat;\n}\n\n.videoChat_control_volume{\n    background-image: url('../../assets/videoChat/volume.png');\n}\n\n.videoChat_control_screen{\n    background-image: url('../../assets/videoChat/screen.png');\n}\n\n.videoChat_control_mic{\n    background-image: url('../../assets/videoChat/mic.png');\n}\n\n.videoChat_control_close{\n    width: 57px;\n    height: 57px;\n    background-color: #E23424;\n    background-image: url('../../assets/videoChat/close.png');\n}\n\n.videoChat_control_camera{\n    background-image: url('../../assets/videoChat/videocam.png');\n}\n\n.videoChat_control_setting{\n    background-image: url('../../assets/videoChat/setting.png');\n}\n\n.videoChat_control_expand{\n    background-image: url('../../assets/videoChat/expand.png');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
